import { html } from "lit";
var icon_pin_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero">
      <path
        d="M20.56 1.14c.83-.09 1.65.2 2.24.79l7.27 7.27a2.74 2.74 0 0 1-.46 4.25l-7.62 4.85.01.05c.38 2.24 0 4.56-1.07 6.57l-.17.3a2.74 2.74 0 0 1-4.3.55L6.22 15.55a2.74 2.74 0 0 1 .55-4.3A10.24 10.24 0 0 1 13.65 10l.05.01 4.85-7.62a2.74 2.74 0 0 1 1.83-1.22l.18-.03Zm-13 11.69a1 1 0 0 0-.09 1.48l10.22 10.22a1 1 0 0 0 1.56-.2 8.49 8.49 0 0 0 .91-6.24.88.88 0 0 1 .38-.95l8.13-5.17a1 1 0 0 0 .16-1.53l-7.27-7.27a1 1 0 0 0-1.53.16l-5.17 8.13a.88.88 0 0 1-.95.38 8.48 8.48 0 0 0-6.25.91l-.1.08Z" />
      <path d="M11.34 19.42a.88.88 0 1 1 1.24 1.24l-9.96 9.96a.88.88 0 0 1-1.24-1.24l9.96-9.96Z" />
    </g>
  </svg>
`;
export {
  icon_pin_default as default
};
//# sourceMappingURL=icon-pin.js.map
